import { createContext, useContext, type ReactNode } from 'react';
import { queryOptions, useQuery } from '@tanstack/react-query';
import type { BannersDto } from '@zoxo/shared';

import { api } from '../../lib/api';

/**
 * 콘솔에서 바꾸는 배너 두 장 (홈 히어로 · 우하단 고정). 값이 없으면 화면은 기본 그림(lib/site)을 쓴다.
 *
 * **서버와 브라우저가 같은 캐시를 읽는다.** 루트 loader 가 `['banners']` 를 채우고, 그 캐시가
 * 라우터 상태에 실려 브라우저로 간다 — 첫 페인트와 hydrate 뒤가 같은 그림이다.
 */
const EMPTY: BannersDto = { hero: null, offside: null };
const BannersContext = createContext<BannersDto>(EMPTY);

export function BannersProvider({ value, children }: { value: BannersDto | null | undefined; children: ReactNode }) {
  return <BannersContext.Provider value={value ?? EMPTY}>{children}</BannersContext.Provider>;
}

export const useBanners = () => useContext(BannersContext);

export const bannersQuery = queryOptions({
  queryKey: ['banners'],
  queryFn: () => api.get<BannersDto>('/banners'),
  staleTime: 5 * 60 * 1000,
});

/** 루트 loader 가 채운 캐시를 이어받고, 없으면 받는다. 실패해도 기본 그림이 있어 화면을 안 막는다. */
export function useBannersQuery() {
  return useQuery(bannersQuery);
}
